import * as React from 'react';

function SvgStageRecord(props) {
  return (
    <svg viewBox="0 0 39 43" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M32.836 6a6 6 0 015.998 6.162l-.495 18.316L25.047 43H12a6 6 0 01-6-6V12a6 6 0 016-6h20.836z"
          fill="#E2F4F2"
        />
        <path
          d="M25.477.022c3.318 0 5.373 1.753 5.474 4.994l.004.252v3.387c0 .796-.492 1.442-1.288 1.442-.749 0-1.228-.572-1.282-1.303l-.005-.139V5.268c0-1.746-1.01-2.607-2.704-2.668l-.198-.004H5.484c-1.746 0-2.821.797-2.898 2.474l-.005.198v25.668c0 1.746 1.011 2.607 2.705 2.668l.198.004h6.847c.796 0 1.441.491 1.441 1.287 0 .75-.571 1.228-1.302 1.282l-.139.005H5.484c-3.317 0-5.372-1.752-5.473-4.994l-.004-.252V5.268C.007 1.95 1.979.115 5.231.025l.253-.003h19.993zm5.877 13.355a.775.775 0 011.01.075l3.154 3.154 1.216 1.193.075.087c.225.303.2.734-.075 1.01l-1.216 1.216-13.536 13.46-2.422.293-.188.018c-1.994.143-3.36-1.27-3.12-3.289l.294-2.42 14.721-14.722zm.5 2.752L18.747 29.16l-.064.133-.205 1.712c-.045.505.169.718.68.672l1.705-.203.132-.064 13.107-13.03-2.248-2.25zm-23.922 8.8h2.99c.796 0 1.441.49 1.441 1.286 0 .75-.571 1.229-1.302 1.283l-.139.005h-2.99c-.796 0-1.441-.492-1.441-1.288 0-.749.571-1.228 1.302-1.282l.139-.005h2.99zm9.013-7.83c.796 0 1.44.492 1.44 1.287 0 .75-.57 1.229-1.302 1.283l-.138.005h-9.07c-.796 0-1.44-.492-1.44-1.288 0-.749.57-1.228 1.301-1.282l.14-.005h9.069zm6.062-8.4c.797 0 1.442.491 1.442 1.287 0 .75-.572 1.228-1.303 1.282l-.139.005H7.875c-.796 0-1.44-.491-1.44-1.287 0-.75.57-1.228 1.301-1.282l.14-.005h15.131z"
          fill="#3AB2A6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgStageRecord;
